<template>
  <div>
    <v-container>
      <CRUDList
        :canAdd="canAddToSharedList"
        :canEdit="true"
        :canSave="canEditSharedList"
        :headers="headers"
        :baseCrudKey="baseCrudKey"
        :createNewItem="newItemDialog"
        toolbarTitle="Comment Types"
        @loadCRUDList="handleLoadCRUDList"
        @upsertItem="upsrtTransaction"
        :defaultSortBy="sortBy"
      >
        <template v-slot:[`editedItem`]="{}">
          <taxCommentEditItem :baseCrudKey="baseCrudKey" />
        </template>
      </CRUDList>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { reservedCommentCode } from '../../../util/shared/tmc-global';
import CRUDList from '../../common/base/crud/CRUDList.vue';
import taxCommentEditItem from './taxCommentEditItem.vue';
import { isAuthorised } from '../../../store/auth/token';
import { authRoles } from '../../../router/roleGroups';
import SharedListAccessControlMixin from '../SharedListAccessControl.mixin';

const getHeaders = () => {
  const headers = [
    { text: 'Comment code', value: 'commentCode' },
    { text: 'Description', value: 'description' },
    { text: 'Message', value: 'comment' },
  ];
  return headers;
};

export default {
  name: 'taxCommentList',
  mixins: [SharedListAccessControlMixin],
  components: {
    CRUDList,
    taxCommentEditItem,
  },
  data: () => ({
    baseCrudKey: 'sharedTaxComments',
    headers: [],
    sortBy: [
      {
        column: 'commentCode',
        direction: 'asc',
      },
    ],
  }),
  created() {
    this.headers = getHeaders();
    this.initCriteria();
  },
  methods: {
    ...mapActions('shared/commentTypes', ['loadCommentTypes', 'upsertTaxCommentTypes']),
    ...mapMutations('base/crud', ['setCriteria']),
    async upsrtTransaction(item) {
      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      delete updatedItem.status;
      // need to restrict user for create code between 1-99 that is reserved for superadmin
      // eslint-disable-next-line max-len
      if ((updatedItem.commentCode >= reservedCommentCode.min) && (updatedItem.commentCode <= reservedCommentCode.max) && this.isSuperAdmin) {
        await this.upsertTaxCommentTypes({ item: updatedItem, baseCrudKey });
      } else {
        const message = `Comment code between ${reservedCommentCode.min} to ${reservedCommentCode.max} reserved for superadmin`;
        alert(message);
      }
    },
    handleLoadCRUDList() {
      const { baseCrudKey } = this;
      const criteria = { ...this.criteriaState };
      this.loadCommentTypes({
        criteria,
        baseCrudKey,
      });
    },
    newItemDialog() {
      let newItem = {};
      newItem = {
        commentCode: '',
        status: '',
        comment: '',
      };
      return newItem;
    },
    initCriteria() {
      this.criteriaState = {};
    },
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'index', 'item']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    isSuperAdmin() {
      return isAuthorised(authRoles.SuperAdmin);
    },
  },
};
</script>
